import React from 'react';
import { connect } from 'react-redux';
import { DBSpecDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestSynergiesRUE extends React.Component {

    render() {

        return(
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Synergies - R UE'/>
                <span className={styles.spacer} />
                <label className={styles.label}>R UE</label>
                <span className={styles.r} />
                <DBSpecDropDownObjective
                    field='TSSYNRUE'
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.c}
                    optionsValue={6}
                />
                <span className={styles.l} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSYNRUE !== null && 
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSYNRUE !== 'None' ) {
        flagged = true;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: flagged
    };
}

const connectedSpecialTestSynergiesRUE = connect(mapStateToProps)(SpecialTestSynergiesRUE);
export { connectedSpecialTestSynergiesRUE as SpecialTestSynergiesRUE };



